/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleFullInit = (component) => () => {
    $(component).slick({
        slidesToShow: 3.33,
        slidesToScroll: 2,
        focusOnSelect: true,
        centerMode: false,
        dots: false,
        arrows: true,
        infinite: true,
        swipeToSlide: true,
        touchThreshold: 200,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};

export default handleFullInit;



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/handleFullInit.js